import { BloomreachProductType } from '../pages/search/hooks/use-search';
import { PageUrl } from '../pages/utils/page-url';

/**
 * Determines the product type based on location pathname and search parameters
 * @param location - The location object containing pathname and search query parameters
 * @returns Product type enum value:
 *   - `BloomreachProductType.hardgood` - For regular products (default, or when pathname starts with `/products`)
 *   - `BloomreachProductType.recipe` - For recipe pages (when pathname starts with `/recipes`)
 *   - `BloomreachProductType.culinary` - For culinary products (when specified in URL params)
 * @remarks
 * Priority order:
 * 1. Checks `productType` query parameter first
 * 2. Falls back to pathname-based detection (`/recipes` or `/products`)
 * 3. Defaults to `hardgood` if no match is found
 */
export const getProductType = (pathname: string, search: string): BloomreachProductType => {
    const params = new URLSearchParams(search);
    const productType = params.get('productType') as BloomreachProductType;
    if (productType) {
        return productType;
    }

    if (pathname && pathname.startsWith(PageUrl.RECIPES)) {
        return BloomreachProductType.recipe;
    }
    if (pathname && pathname.startsWith(PageUrl.PRODUCTS)) {
        return BloomreachProductType.hardgood;
    }

    // Default to hardgood
    return BloomreachProductType.hardgood;
};
